import type { Tag } from 'react-tag-input';
import { z } from 'zod';

export const editorPickSchema = z.object({
  location: z.string().refine((value) => value !== '' && value !== 'default', {
    message: 'common.form.validation.required',
  }),
  clubId: z.string().refine((value) => value !== '' && value !== 'default', {
    message: 'common.form.validation.required',
  }),
  description: z
    .string()
    .min(1, { message: 'common.form.validation.required' })
    .max(200, { message: 'common.form.error.descriptionMaxLength' })
    .optional(),
  tags: z.array(
    z
      .object({
        id: z.string(),
        text: z.string().optional(),
        className: z.string(),
      })
      .optional(),
  ),
});
export type EditorPickFormValues = {
  location: string;
  clubId: string;
  description: string;
  tags: Tag[];
};
